export default __webpack_public_path__ + "static/9-8649bc538df9d46c1e107c9ba164dbb7.jpg";